export const DeliveryTimeout = Object.freeze({
	Default: 300,
	WithFiles: 3600,
});
